var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStartingFrom = function SvgStartingFrom(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 57,
    viewBox: "0 0 18 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 57,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Employees"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1718 -6514C-1718 -6596.84 -1650.84 -6664 -1568 -6664H12820C12902.8 -6664 12970 -6596.84 12970 -6514V4208.85C12970 4280.64 12911.8 4338.85 12840 4338.85H-1588C-1659.8 4338.85 -1718 4280.64 -1718 4208.85V-6514Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1568 -6663H12820V-6665H-1568V-6663ZM12969 -6514V4208.85H12971V-6514H12969ZM12840 4337.85H-1588V4339.85H12840V4337.85ZM-1717 4208.85V-6514H-1719V4208.85H-1717ZM-1588 4337.85C-1659.24 4337.85 -1717 4280.09 -1717 4208.85H-1719C-1719 4281.2 -1660.35 4339.85 -1588 4339.85V4337.85ZM12969 4208.85C12969 4280.09 12911.2 4337.85 12840 4337.85V4339.85C12912.3 4339.85 12971 4281.2 12971 4208.85H12969ZM12820 -6663C12902.3 -6663 12969 -6596.29 12969 -6514H12971C12971 -6597.39 12903.4 -6665 12820 -6665V-6663ZM-1568 -6665C-1651.39 -6665 -1719 -6597.39 -1719 -6514H-1717C-1717 -6596.29 -1650.29 -6663 -1568 -6663V-6665Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "add_new_employee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1638 -559.152C-1638 -586.767 -1615.61 -609.152 -1588 -609.152H3957C3984.61 -609.152 4007 -586.767 4007 -559.152V571.848C4007 599.462 3984.61 621.848 3957 621.848H-1588C-1615.61 621.848 -1638 599.462 -1638 571.848V-559.152Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1588 -608.152H3957V-610.152H-1588V-608.152ZM4006 -559.152V571.848H4008V-559.152H4006ZM3957 620.848H-1588V622.848H3957V620.848ZM-1637 571.848V-559.152H-1639V571.848H-1637ZM-1588 620.848C-1615.06 620.848 -1637 598.91 -1637 571.848H-1639C-1639 600.014 -1616.17 622.848 -1588 622.848V620.848ZM4006 571.848C4006 598.91 3984.06 620.848 3957 620.848V622.848C3985.17 622.848 4008 600.014 4008 571.848H4006ZM3957 -608.152C3984.06 -608.152 4006 -586.214 4006 -559.152H4008C4008 -587.319 3985.17 -610.152 3957 -610.152V-608.152ZM-1588 -610.152C-1616.17 -610.152 -1639 -587.319 -1639 -559.152H-1637C-1637 -586.214 -1615.06 -608.152 -1588 -608.152V-610.152Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "new_employee (1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4443_11075)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -529.152,
    width: 700,
    height: 990,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1597878802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2147223709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2147223947"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2147224051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2147224050",
    clipPath: "url(#clip1_4443_11075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 271",
    d: "M9 0.695312H65H9ZM65 36.6953C65 39.1806 62.9853 41.1953 60.5 41.1953H13C10.5147 41.1953 8.5 39.1806 8.5 36.6953H9.5C9.5 38.6283 11.067 40.1953 13 40.1953H61C63.2091 40.1953 65 38.6283 65 36.6953ZM13 41.1953C10.5147 41.1953 8.5 39.1806 8.5 36.6953V0.695312H9.5V36.6953C9.5 38.6283 11.067 40.1953 13 40.1953V41.1953ZM65 0.695312V40.6953V0.695312Z",
    fill: "#E3E6EB"
  })))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4443_11075"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -529.152,
    width: 700,
    height: 990,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4443_11075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 56,
    fill: "white",
    transform: "translate(0 0.847656)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStartingFrom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "starting-from.81e308107617ae533e08ce739dd1619e.svg";